import React from "react";
import { dispatchMiddleware, enrichContextState } from "nemuru-components";
import { LoginMapper } from "../utils/mappers/LoginMapper";
import { services } from "../request/services";
import { developOptions } from "../config/developOptions";
import { LoanMapper } from "../utils/mappers/LoanMapper";
export const AuthContext = React.createContext();

const initialState = {
  logged: undefined,
  loggedOut: undefined,
  token: null,
  tokenToSet: null,
  authentication: undefined,
  loading: false,
  passwordChanged: false,
  authError: null,
  profile: undefined,
  username: "",
  password: "",
  criticalError: null,
};

const actions = {
  LOGOUT: {
    changeState: (state, action) => {
      return {
        ...state,
        loading: false,
        authentication: false,
        token: null,
        profile: null,
      };
    },
  },
  SET_TOKEN: {
    changeState: (state, action) => {
      return { ...state, token: action.payload };
    },
  },
  UPDATE_AUTH_CONTEXT: {
    changeState: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
  SET_AUTHENTICATION: {
    changeState: (state, action) => {
      return { ...state, authentication: action.payload };
    },
  },
  RESET_AUTH_ERROR: {
    changeState: (state) => ({ ...state, authError: null }),
  },
  REQUEST_GET_LOAN_BEFORE_AGENT_SEQUENCE: {
    request: services.getLoan,
    changeState: (state, action) => {
      return { ...state, loading: true };
    },
  },
  [`${"REQUEST_GET_LOAN_BEFORE_AGENT_SEQUENCE"}_FULFILLED`]: {
    chainAction: (action) => {
      return {
        type: "REQUEST_GET_AGENT",
        payload: action.payload.payload.agent_id,
      };
    },

    changeState: (state, action) => {
      const loan = action.payload.payload;
      return {
        ...state,
        eventsId: {
          loanId: loan.id,
          borrowerId: loan.borrower_id,
        },
        loanOnAppStart: LoanMapper.hydrate(loan),
        lastRequestAction: action.type,
      };
    },
  },
  [`${"REQUEST_GET_LOAN_BEFORE_AGENT_SEQUENCE"}_REJECTED`]: {
    changeState: (state, action) => {
      return {
        ...state,
        loading: false,
        criticalError: action.type,
      };
    },
  },
  REQUEST_GET_AGENT: {
    request: services.getAgentById,
    changeState: (state, action) => {
      return { ...state, loading: true, agent: null };
    },
  },
  [`${"REQUEST_GET_AGENT"}_FULFILLED`]: {
    changeState: (state, action) => {
      return { ...state, agent: action.payload.payload, loading: false };
    },
  },
  [`${"REQUEST_GET_AGENT"}_REJECTED`]: {
    changeState: (state, action) => {
      return {
        ...state,
        loading: false,
        gettingAgent: false,
        agent: null,
        snackbarNotification: {
          snackbarInformation: action,
          level: "error",
        },
      };
    },
  },
  REQUEST_POST_SESSION_TOKEN: {
    request: services.postSessionToken,
    changeState: (state, action) => {
      return {
        ...state,
        loading: true,
        authentication: undefined,
        authError: null,
        profile: null,
      };
    },
  },
  [`${"REQUEST_POST_SESSION_TOKEN"}_FULFILLED`]: {
    changeState: (state, action) => {
      return {
        ...state,
        loading: false,
        authentication: true,
        tokenToSet: LoginMapper.hydrate({
          access_token: action.payload.access_token,
          expires_in: action.payload.expires_in,
          lid: action.requestPayload.lid,
        }),
      };
    },
  },
  [`${"REQUEST_POST_SESSION_TOKEN"}_REJECTED`]: {
    changeState: (state, action) => {
      return {
        ...state,
        loading: false,
        authentication: false,
        authError: action.payload || "undefined error",
      };
    },
  },
};

function reducer(state, action) {
  const originalState = actions[action.type].changeState(state, action);
  return enrichContextState(actions[action.type], originalState, action);
}

export default function AuthContextProvider(props) {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const middlewareDispatch = dispatchMiddleware(
    dispatch,
    actions,
    developOptions
  );
  const value = { state, dispatch: middlewareDispatch };

  return (
    <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
  );
}
